import { useFormContext, useWatch } from 'react-hook-form';

export function StakingTotalAmount() {
  const { control } = useFormContext();
  const count = Number(useWatch({ control, name: 'count' }));
  const amount = Number(useWatch({ control, name: 'amount' }));
  return (
    <>
      {count >= 1 &&
      count <= 100 &&
      Number.isInteger(count) &&
      amount >= 32 &&
      amount <= 2048
        ? count * amount
        : '-'}{' '}
      ETH
    </>
  );
}
